import {compose} from 'redux';
import {connect} from 'react-redux';
import {WithWindow} from 'epic-diesel-common/src/hocs';
import {selectProductMetaByProductNameAndSlug} from 'epic-diesel-common/src/redux/selectors/product.selectors';
import {mapMessageStateToProps} from 'epic-diesel-common/src/components/message/Message';
import PostPurchaseToastItem from './PostPurchaseToastItem';

const mapStateToProps = (state, ownProps) => {
    const {productName, productSlug} = ownProps.data.toJS();

    const {metaProductImage, metaProductName} = selectProductMetaByProductNameAndSlug(state, {
        productName,
        productSlug
    });

    return {
        ...mapMessageStateToProps(state),
        image: metaProductImage,
        productName: metaProductName
    };
};

const mapDispatchToProps = dispatch => ({
    primaryAction: (id: number) => dispatch(null),
    secondaryAction: (id: number) => dispatch(null)
});

export default compose(
    connect(
        mapStateToProps,
        mapDispatchToProps
    ),
    WithWindow
)(PostPurchaseToastItem);
